module.exports = __webpack_public_path__ + "fd26ff23f831db9ae85a805386529385.woff2";